import { memo } from "react";
import { DatePicker as MuiDatePicker, type DatePickerProps as MuiDatePickerProps } from "@mui/x-date-pickers-pro";
import CalendarIcon from "components/Icons/CalendarIcon";
import ChevronRightIcon from "components/Icons/ChevronRightIcon";
import ChevronLeftIcon from "components/Icons/ChevronLeftIcon";
import ChevronDownIcon from "components/Icons/ChevronDownIcon";
import DatePickerLayout from "components/DatePickerLayout";

function DatePicker(props: MuiDatePickerProps) {
  const { format = "ddd, DD MMM YYYY", ...rest } = props;
  return (
    <MuiDatePicker
      {...rest}
      format={format}
      slots={{
        openPickerIcon: CalendarIcon,
        rightArrowIcon: () => <ChevronRightIcon fontSize="small" />,
        leftArrowIcon: () => <ChevronLeftIcon fontSize="small" />,
        switchViewIcon: () => <ChevronDownIcon fontSize="small" />,
        layout: DatePickerLayout,
      }}
      slotProps={{
        ...rest?.slotProps,
        openPickerButton: {
          sx: {
            color: "primary.main",
            "&.Mui-disabled": { color: "grey.100" },
          },
        },
        textField: {
          ...rest?.slotProps?.textField,
          variant: "standard",
          fullWidth: true,
          sx: {
            "& .MuiPickersInputBase-root": {
              paddingTop: "2px",
              marginTop: "21px",
            },
            "& .MuiPickersInputBase-root.Mui-disabled": {
              color: "grey.100",
              ":before": { borderBottomStyle: "solid" },
            },
          },
        },
      }}
    />
  );
}

export default memo(DatePicker);
